import { FC, useMemo } from 'react';

import classNames from 'classnames';

import './Linear.scss';

import { SizeOptions, TestMetadata } from '../types';

export interface LinearProps {
  /** Add a class to the spinner */
  className?: string;
  /** Size: small, medium, large */
  size?: SizeOptions;
  // Test IDs for component sections
  testMetadata?: TestMetadata;
  /** variant */
  variant?: 'determinate' | 'indeterminate';
  /** max value for determinate variant */
  max?: number;
  /** current value for determinate variant */
  value?: number;
  /** to show or hide label */
  showLabel?: boolean;
}

const Linear: FC<LinearProps> = ({
  className,
  size,
  testMetadata,
  variant = 'indeterminate',
  value = 0,
  max = 100,
  showLabel = false,
  ...otherProps
}) => {
  const currentValue = useMemo(() => {
    if (value >= 0 && max > 0) {
      if (value > max) return 100;
      return Math.round((value / max) * 100);
    }
    return 0;
  }, [max, value]);

  return (
    <div
      {...otherProps}
      className={classNames('sb-linear-container', className, {
        'sb-linear-small': size === 'small',
        'sb-linear-large': size === 'large',
      })}
      role="alert"
      aria-live="assertive"
      {...testMetadata}
    >
      <div
        className={`sb-${variant}`}
        data-testid={
          testMetadata?.['data-testid'] ? 'linear-variant' : undefined
        }
      />
      {variant === 'determinate' && (
        <>
          <div
            className={classNames(
              'sb-determinate-bar',
              `sb-${variant}-bar_${currentValue}`,
            )}
          />
          {showLabel && (
            <div className="sb-determinate-label">{`${currentValue}%`}</div>
          )}
        </>
      )}
    </div>
  );
};

export default Linear;
